// src/components/PurchaseInvoices.js
import React, { useState } from 'react';
import ViewModal from './ViewModal';
import ColumnManager from './ColumnManager';
import InlineEditForm from './InlineEditForm';

const PurchaseInvoices = ({ invoices, onDelete, onUpdate, columns, setColumns }) => {
  const [editingId, setEditingId] = useState(null);
  const [viewingInvoice, setViewingInvoice] = useState(null);
  const [showColumnManager, setShowColumnManager] = useState(false);

  // مرتب‌سازی ستون‌ها بر اساس order
  const sortedColumns = [...columns].sort((a, b) => a.order - b.order);
  const visibleColumns = sortedColumns.filter(col => col.visible);

  const handleDelete = (id) => {
    if (window.confirm('آیا از حذف این فاکتور مطمئن هستید؟')) {
      onDelete(id);
      if (editingId === id) setEditingId(null);
    }
  };

  const handleView = (invoice) => {
    setViewingInvoice(invoice);
  };

  const handleEdit = (id) => {
    setEditingId(editingId === id ? null : id);
  };

  const updateInvoice = (id, updatedInvoice) => {
    onUpdate(id, updatedInvoice);
    setEditingId(null);
  };

  const formatPrice = (price) => {
    return price.toLocaleString('fa-IR');
  };

  return (
    <div className="purchase-invoices">
      <div className="invoices-header">
        <h2>لیست فاکتورهای خرید</h2>
        <button className="btn-manage-columns" onClick={() => setShowColumnManager(true)}>
          ⚙️ مدیریت ستون‌ها
        </button>
      </div>

      <table className="invoices-table">
        <thead>
          <tr>
            {visibleColumns.map(col => (
              <th key={col.id}>{col.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {invoices.map(invoice => (
            <React.Fragment key={invoice.id}>
              <tr className={editingId === invoice.id ? 'editing-row' : ''}>
                {visibleColumns.map(col => {
                  if (col.id === 'actions') {
                    return (
                      <td key={col.id} className="actions-cell">
                        <button className="btn-view" onClick={() => handleView(invoice)}>👁️</button>
                        <button className="btn-edit" onClick={() => handleEdit(invoice.id)}>✏️</button>
                        <button className="btn-delete" onClick={() => handleDelete(invoice.id)}>🗑️</button>
                      </td>
                    );
                  }
                  if (col.id === 'totalAmount') {
                    return <td key={col.id}>{formatPrice(invoice.totalAmount)}</td>;
                  }
                  return <td key={col.id}>{invoice[col.id]}</td>;
                })}
              </tr>
              {editingId === invoice.id && (
                <tr className="inline-edit-row">
                  <td colSpan={visibleColumns.length}>
                    <InlineEditForm
                      invoice={invoice}
                      onSave={updateInvoice}
                      onCancel={() => setEditingId(null)}
                    />
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>

      {viewingInvoice && (
        <ViewModal invoice={viewingInvoice} onClose={() => setViewingInvoice(null)} />
      )}

      {showColumnManager && (
        <ColumnManager
          columns={columns}
          setColumns={setColumns}
          onClose={() => setShowColumnManager(false)}
        />
      )}
    </div>
  );
};

export default PurchaseInvoices;